<template>
    <b-modal id="groupCodeSearch" :title="title" size="md" @show="fn_search">
        <div class="table_list">
            <ul class="search_filter">
                <li>
                    <p>{{ searchName }}</p>
                    <input type="text" :placeholder="`${searchName}을(를) 입력하세요`" class="form_control" v-model="groupCodeName" @keyup.enter="fn_search">
                    <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
                </li>
            </ul>
            <div class="modal_table">
                <table class="list">
                    <colgroup>
                        <col width="50">
                        <col width="50">
                    </colgroup>
                    <thead>
                        <tr>
                            <th></th>
                            <th>No</th>
                            <th>그룹코드</th>
                            <th>그룹코드명</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in groupCodeList" :key="index">
                        <td>
                            <div class="form_checkbox">
                                <input type="checkbox" :id="'checkbox'+index" name="checkbox" v-model="checkBox" :value="index" @change="fn_check">
                                <label :for="'checkbox'+index"></label>
                            </div>
                        </td>
                        <td><span>{{ index + 1 }}</span></td>
                        <td><span>{{ item.code }}</span></td>
                        <td><span>{{ item.code_nm }}</span></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <template #modal-footer="{ ok }">        
            <b-button class="btn btn_md btn_gray" v-show="oneBtn" @click="fn_apply">{{ btnLeft }}</b-button>
            <b-button class="btn btn_md btn_deepblue" @click="fn_init(),ok()">{{ btnRight }}</b-button>
        </template>
    </b-modal>

</template>

<script>
    import axios from 'axios'

    export default {
        name: 'groupCodeSearch',
        props: {
            title: String,
            btnLeft: String,
            btnRight: String,
            searchName: String,
            searchData: String,
            oneBtn: Boolean,
            filter: Boolean,
        },
        data() {
            return {
                checkBox : [],
                groupCodeList : [],
                groupCodeName : this.searchData
            }
        },
        watch : {
            searchData(newValue) {
                //console.log("변경 체크");
                //props 변경 여부 확인
                this.groupCodeName = newValue;

            }
        },
        methods : {
            fn_search(){

                let param = new Object();
                param.grpCodeNm = this.grpCodeNm;

              axios
                    .post("/api/system/searchGroupCodeList", param)
                    .then((res) => {
                        this.groupCodeList = res.data.groupCodeList;
                    })
                    .catch((err) => console.log(err));
                
            },
            fn_apply(){
                               
                if(this.checkBox.length == 0){
                    alert("체크된 약재가 없습니다.");
                }else if(this.checkBox.length > 1){
                    alert("한개 이상 선택할수 없습니다.");
                }else{                    
                    
                    let medObject = this.groupCodeList[this.checkBox[0]];

                    this.$emit('callback', medObject);

                    this.fn_init();
                    this.$bvModal.hide('groupCodeSearch');
                }                                        
            },
            fn_init(){
                this.groupCodeList = [];
                this.checkBox = [];
                this.groupCodeName = '';
            },
            fn_check(){
                if(this.checkBox.length > 1){
                    this.checkBox.splice(0,1);
                }
            }
        }
    }
</script>
